// Тема light/dark (перенос из демо), сохраняется в localStorage.
const KEY = 'azam_theme';
export type Theme = 'light' | 'dark';

export function getTheme(): Theme {
  const saved = localStorage.getItem(KEY);
  // По умолчанию — светлая тема (как в мокапе); тёмная включается переключателем.
  return saved === 'dark' || saved === 'light' ? saved : 'light';
}

export function applyTheme(t: Theme): void {
  document.documentElement.setAttribute('data-theme', t);
  localStorage.setItem(KEY, t);
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === 'dark' ? 'light' : 'dark';
  applyTheme(next);
  return next;
}
